import CryptoJS from "crypto-js";

export const encrypt = data => {
    const sortedKeys = Object.keys(data).sort();
    let str = "";
    for (let key of sortedKeys) {
        if (data[key]) {
            str += `${key}=${data[key]}&`;
        }
    }
    // 删除最后一个&
    str = str.slice(0, str.length - 1);
    const secretKey = "89f4c9243c6548a0b792b5e320afa479";
    str += secretKey;

    return CryptoJS.MD5(str).toString();
};
